export default __webpack_public_path__ + "static/media/IMG-20240822-WA0010.15fd4920.jpg";